import { render, staticRenderFns } from "./Snap.vue?vue&type=template&id=5db0e718&scoped=true&"
import script from "./Snap.vue?vue&type=script&lang=js&"
export * from "./Snap.vue?vue&type=script&lang=js&"
import style0 from "./Snap.vue?vue&type=style&index=0&id=5db0e718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0e718",
  null
  
)

export default component.exports